import React, { useState } from 'react';
import { getImages } from '../Const';

const defaultFeatures = [
    "Sun Roof",
    "Rear Sunshades",
    "Leather Seats",
    "Heated Seats",
    "Ventilated Seats",
    "Navigation System",
    "Bluetooth Connectivity",
    "Backup Camera",
    "Blind Spot Monitoring",
    "Adaptive Cruise Control",
    "Apple CarPlay / Android Auto",
    "Keyless Entry & Push Start"
];

const EditVehicleOptions = ({setSelectedOptions, selectedOptions}) => {
    const [features, setFeatures] = useState([...new Set([...defaultFeatures,...selectedOptions])]);
    const [newFeature, setNewFeature] = useState('');

    const handleCheckboxChange = (option) => {
        setSelectedOptions((prev) =>
            prev.includes(option)
                ? prev.filter((item) => item !== option)
                : [...prev, option]
        );
    };

    const removeOption = (option) => {
        setSelectedOptions((prev) => prev.filter((item) => item !== option));
    };

    const handleAddFeature = () => {
        const trimmedFeature = newFeature.trim();
        if (
            trimmedFeature &&
            !features.includes(trimmedFeature)
        ) {
            setFeatures((prev) => [...prev, trimmedFeature]);
            setSelectedOptions((prev) =>
                prev.includes(trimmedFeature) ? prev : [...prev, trimmedFeature]
            );
            setNewFeature('');
        }
    };

    return (
        <>
            {/* Left Column */}
            <div className="col-md-6">
                <div className="mb-4">
                    <div className="adr-label fw-600 text-uppercase mb-2">Vehicle Options</div>
                    <div className='evo-box'>
                        {features.map((option, index) => (
                            <div key={index} className="custom-checkbox evo-checkbox mb-1">
                                <input
                                    type="checkbox"
                                    id={`option-${index}`}
                                    checked={selectedOptions.includes(option)}
                                    onChange={() => handleCheckboxChange(option)}
                                />
                                <label htmlFor={`option-${index}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='add-option-block mb-4'>
                    <div className='adr-label mb-1'>Add Option</div>
                    {/* Add New Feature */}
                    <div className="row">
                        <div className='col-md-7'>
                            <input
                                type="text"
                                className="form-control"
                                value={newFeature}
                                 onChange={(e) => setNewFeature(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                    e.preventDefault(); 
                                    handleAddFeature();
                                    }
                                }}
                                placeholder="Ex: Roof Rack"
                            />
                        </div>
                        <div className='col-md-5'>
                            <button
                                type="button"
                                className="add-option-btn"
                                onClick={handleAddFeature}
                            >
                            <span className='blue-add-icon'></span> Add Option
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Column */}
            <div className="col-md-6">
                <div className="mb-4">
                    <div className="adr-label fw-600 text-uppercase mb-2">Options Selected</div>
                    <div className="d-flex flex-wrap gap-2">
                        {selectedOptions.map((option, index) => (
                            <div
                                key={index}
                                className="evo-tag d-flex align-items-center"
                            >
                                {option}
                                <button
                                    type="button"
                                    className="evo-close ms-auto pe-0"
                                    aria-label="Close"
                                    onClick={() => removeOption(option)}
                                >
                                    <img src={getImages('close-anticon.svg')} alt="remove" />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditVehicleOptions;
